import { useTranslation } from "react-i18next";

export default function useTranslations() {
    const [ t ] = useTranslation('translation');
    return t;
}
